import {TRANS} from "@/assets/plugins/mps-common/translation/messages";
import {vm} from "@/main";
import {exec, REGEX} from "@/assets/plugins/mps-common/rules/regex";

const RULES = {
    loginId: v => !!v && !!REGEX.LOGIN_ID.exec(v) || TRANS.LOGIN_ID_INVALID,
    password: v => !!v && !!REGEX.LOGIN_PW.exec(v) || TRANS.LOGIN_PW_INVALID,
};

/**
 * 룰을 검증하고 true 를 리턴하거나 또는 message 를 alert 으로 띄운 뒤 false 를 리턴합니다.
 */
const checkRule = (rule) => {
    if (rule !== true) {
        vm.$alert(rule); // 실패시 rule 은 message 입니다.
        return false;
    }

    return true;
}

export {RULES, checkRule};